import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react-17';

class MapContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zoom: 6,
            center: { lat: 51.5200, lng: 18.4050 } 
     
        };

    }

    handleMarkerClick = (markerProps, marker, e) => {
        
        this.setState({zoom: 12}); 
        const { position } = markerProps;
let postionNumb = {lat: parseFloat(position.lat), lng: parseFloat(position.lng)}
        // Przesuń mapę do klikniętego markera
        this.map.panTo(postionNumb);
    }
    onMapReady = (mapProps, map) => {
        // Po zakończeniu inicjalizacji mapy, zapisz referencję do mapy
        this.map = map;

        // Dodaj obsługę zdarzenia zmiany przybliżenia
        map.addListener('zoom_changed', () => {
            this.setState({ zoom: map.getZoom() });
        });
    }
    render() {

        const { zoom, center } = this.state;
            const { locations } = this.props;
     
        const mapStyles = {
            
        };
       
        return (
            
            <Map
                google={this.props.google}
                zoom={zoom}
                style={mapStyles}
                className={"googleMapa"}
                initialCenter={center} // Współrzędne geograficzne dla centrum mapy
                onReady={this.onMapReady}
            >
                 {locations.map(place => (
                    <Marker
                        key={place.id}
                        
                        position={{ lat: place.lat, lng: place.lon }}
                        title={place.loc}
                        onClick={this.handleMarkerClick}
                    />
                ))}
            
            
               
             
            
            </Map>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyCs2UmlYjbJ3rygCMtlDsB1wIWAphP9nyg"  // Włóż swój klucz API Google Maps tutaj
})(MapContainer);